<template lang="pug">
  .auth--confirm

    p(v-html="$t('oauth.title', { service: getServiceName()})")

    //- img.application__logo(
    //-   :alt="service"
    //-   :src="getAppLogo()")

    //- h2 {{ $t('oauth.subtitle') }}

    ul.listScopes
      li
        .listScopes__title
          span(v-html="$t('oauth.scope', { app: appName })")
          i.van-icon.van-icon-more(:class="{'open': showDescription}" @click="toggleDescription")

        .description(:class="{'open': showDescription}")
          hr

          | {{ $t('oauth.description.intro') }}

          ul
            li {{ $t('oauth.description.list1', { service: getServiceName(), app: appName, device: deviceType}) }}
            li {{ $t('oauth.description.list2', { service: getServiceName(), app: appName, device: deviceType }) }}
              ul
                li {{ $t('oauth.description.list21') }}
                li {{ $t('oauth.description.list22') }}
            li {{ $t('oauth.description.list3', { service: getServiceName(), app: appName }) }}

    .links
      a.link(v-if="certPrivacy" :href="certPrivacy" target="_blank") {{ $t('oauth.privacy') }}
      a.link(v-if="certTerms" :href="certTerms" target="_blank") {{ $t('oauth.term') }}

    hr.no-padding-top.margin-bottom

    //- Submit button
    van-button(
      size="large"
      type="primary"
      @click="$emit('authorize')") {{ $t('oauth.allow') }}

    a.cancel(@click="cancel") {{ $t('oauth.cancel') }}
</template>

<script>
import i18n from '@/locales/i18n';
import { PROYECT } from '@/constant';
import axios from 'axios';

export default {
  data() {
    return {
      appName: PROYECT.NAME,
      deviceType: PROYECT.DEVICE,
      showDescription: false,
      certPrivacy: null,
      certTerms: null,
    };
  },
  props: {
    serviceId: {
      type: String,
      default: '',
    },
  },
  methods: {
    getServiceName() {
      switch (this.serviceId) {
        case 'ALEXA':
          return 'Alexa';
        case 'GOOGLE':
          return 'Google';
        case 'IFTTT':
          return 'Ifttt';
        case 'OPENAPI':
          return 'Openapi';
        default:
          return '';
      }
    },

    /* prettier-ignore */
    getCertPrivacy(language, service) {
      switch (service) {
        case 'ALEXA':
          return PROYECT.ALEXA.PRIVACY[language] || PROYECT.ALEXA.PRIVACY.ES;
        case 'GOOGLE':
          return PROYECT.GOOGLE.PRIVACY[language] || PROYECT.GOOGLE.PRIVACY.ES;
        default:
          return '';
      }
    },

    /* prettier-ignore */
    getCertTerms(language, service) {
      switch (service) {
        case 'ALEXA':
          return PROYECT.ALEXA.TERMS[language] || PROYECT.ALEXA.TERMS.ES;
        case 'GOOGLE':
          return PROYECT.GOOGLE.TERMS[language] || PROYECT.GOOGLE.TERMS.ES;
        default:
          return '';
      }
    },

    toggleDescription() {
      this.showDescription = !this.showDescription;
    },

    cancel() {
      window.localStorage.removeItem('token');
      axios.defaults.headers.common.Authorization = '';
      this.$router.push({ name: 'home' });
    },
  },
  created() {
    const language = i18n.locale.toUpperCase();
    this.certPrivacy = this.getCertPrivacy(language, this.serviceId);
    this.certTerms = this.getCertTerms(language, this.serviceId);
  },
};
</script>
